import * as actionTypes from '../actions/actionTypes';
import ResponseErrorMessages from '../errors/ResponseErrorMessages';

const initialState = {
  loading: false,
  error: false,
  errorMessage: '',
  notificationSent: false,
};

const reducer = (state = initialState, action:any) => {
  switch (action.type) {
    case actionTypes.forgotUsername.SEND_EMAIL:
      return {
        ...state,
        loading: true,
        notificationSent: false,
      };
    case actionTypes.forgotUsername.SEND_EMAIL_RESPONSE:
      if (typeof action.emailResponse.ResponseCode !== 'undefined') {
        return {
          ...state,
          loading: false,
          error: true,
          errorMessage: ResponseErrorMessages.get(action.emailResponse.ResponseCode),
        };
      } else {
        return {
          ...state,
          loading: false,
          error: false,
          notificationSent: true,
        };
      }
    case actionTypes.forgotUsername.CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        error: false,
        errorMessage: '',
      };
    default:
      return state;
  }
};

export default reducer;
